import { useEffect, useMemo, useState } from "react";
import cn from "classnames";
import { HTMLProps } from "react";
import { createContext } from "react";
import { Element } from "../..";
import Item from "./Item";

export interface IRadioContext {
    value: string | number;
    onChange: (value: string | number) => void;
}

export const RadioContext: any = createContext<IRadioContext | null>(null);

interface IProps extends HTMLProps<HTMLElement> {
    initialValue?: string | number;
    value?: string | number;
    onChange?: (value: any) => void;
}

const Radio = (props: IProps) => {
    const {
        children,
        initialValue,
        value,
        className = "",
        onChange,
        ...radioProps
    } = props;
    const [selected, setSelected] = useState(initialValue);

    useEffect(() => {
        if (value !== selected) {
            setSelected(value);
        }
    }, [value]);

    const valueContext = useMemo(
        () => ({
            value: selected,
            onChange: (value: any) => {
                setSelected(value);
                if (onChange) {
                    onChange(value);
                }
            },
        }),
        [selected]
    );

    return (
        <RadioContext.Provider value={valueContext}>
            <Element {...radioProps} className={cn("radio-group", className)}>
                {children}
            </Element>
        </RadioContext.Provider>
    );
};

Radio.Item = Item;

export default Radio;
